import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6ba31d2c&scoped=true&lang=html&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba31d2c",
  null
  
)

export default component.exports